module.exports = __webpack_public_path__ + "img/位图备份1111.69ea0d63.png";